import React, { useState, useEffect } from 'react'
import Wrapper from '../../components/Wrapper'
import { useNavigate, Link } from 'react-router-dom'
import { Box, Typography, Grid, Card, CardContent, ToggleButton, ToggleButtonGroup, Paper, TablePagination, Button } from '@mui/material'

import { menu,included, input,employee as employeeTranslate } from '../../translate'
import Api from '../../Api'
import EmployeeTable from '../../components/new_component/EmployeeTable'
import { toast } from 'react-toastify'

import { cardStyles, greenTheme } from '../../helpers/style'

const { REACT_APP_SERVER } = process.env;
const primaryColor = REACT_APP_SERVER === 'ATS' ? '#0973b9' : greenTheme.primary;
const hoverColor = REACT_APP_SERVER === 'ATS' ? '#075a8f' : greenTheme.hover;
function Employees() {
  const navigate = useNavigate()
  const langIndex = +localStorage.getItem('atsLang') || 1
  const [viewMode, setViewMode] = useState('table')
  const [employees, setEmployees] = useState([])
  const [filteredEmployees, setFilteredEmployees] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(9)

  useEffect(() => {
    fetchEmployees()
  }, [viewMode])

  useEffect(() => {
    let filtered = employees
    
    // Filter out employees with redirect_output length < 8 when in card view
    if (viewMode === 'card') {
      filtered = filtered.filter(employee => {
        if (employee.redirect_output && String(employee.redirect_output).length < 8) {
          return false
        }
        return true
      })
    }
    
    if (searchQuery) {
      const query = searchQuery.toLowerCase()
      filtered = filtered.filter(employee => {
        const searchableFields = [
          employee.buddy,
          employee.notes,
          employee.email,
          employee.redirect_output,
          employee.telegram_phone,
          employee.sip_ip,
          employee.short,
          // employee.group_virtual,
        ]
        return searchableFields.some(field => 
          field !== null && 
          field !== undefined && 
          String(field).toLowerCase().includes(query)
        )
      })
    }
    
    setFilteredEmployees(filtered)
    setPage(0) // Reset to first page when filter changes
  }, [searchQuery, employees, viewMode])

  const fetchEmployees = async () => {
    setLoading(true)
    try {
      const response = await Api.employeeGetEmployees()
      if (response?.data?.status === 'ok') {
        const employeesList = response.data.employees || []
        // Deduplicate by buddy or id
        const uniqueEmployees = employeesList.filter((emp, index, self) => 
          index === self.findIndex(e => (e.buddy && e.buddy === emp.buddy) || (e.id && e.id === emp.id))
        )
        setEmployees(uniqueEmployees)
        
        // Filter out employees with redirect_output length < 8 when in card view
        let filtered = uniqueEmployees
        if (viewMode === 'card') {
          filtered = uniqueEmployees.filter(emp => {
            if (emp.redirect_output && String(emp.redirect_output).length < 8) {
              return false
            }
            return true
          })
        }
        setFilteredEmployees(filtered)
      }
    } catch (error) {
      console.error('Error fetching employees:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleSearchChange = (value) => {
    setSearchQuery(value)
  }

  const handleViewModeChange = (event, newViewMode) => {
    if (newViewMode !== null) {
      setViewMode(newViewMode)
    }
  }

  const handleEdit = (id) => {
    navigate(`/employees/${id}`)
  }

  const handleDelete = async (id) => {
    const deleteText = langIndex === 1 ? "Are you sure you want to delete?" :
      langIndex === 2 ? "Вы уверены, что хотите удалить?" :
        "Վստա՞հ եք, որ ցանկանում եք ջնջել"
    
    if (window.confirm(deleteText)) {
      try {
        await Api.employeeDelete(id)
        setEmployees(prev => prev.filter(e => e.id !== id && e.buddy !== id))
        setFilteredEmployees(prev => prev.filter(e => e.id !== id && e.buddy !== id))
        toast.success('Employee deleted successfully')
      } catch (error) {
        console.error('Error deleting employee:', error)
        toast.error('Error deleting employee')
      }
    }
  }

  const handleAdd = () => {
    navigate('/employees/add')
  }



  // Transform employees data for ShortTable
  const tableData = employees

  return (
    <Wrapper>
      {viewMode === 'table' ? (
        <>
          <EmployeeTable 
            data={tableData}
            loading={loading}
            title={menu.worker[langIndex]}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onAdd={handleAdd}
            viewMode={viewMode}
            onViewModeChange={handleViewModeChange}
          />
        </>
      ) : (
       <div className="tableParent">
      
       </div>
      )}
    </Wrapper>
  )
}

export default Employees
